import React from 'react'
import {Flex} from '/app/src/component'
import MenuSubTitle from '/app/src/component/Menu/SubTitle';
import MenuSubItem  from '/app/src/component/Menu/SubItem';

class CompanySettings extends React.Component {
    render(){
        return (
            <Flex column grow>
                <MenuSubTitle
                    svgSrc='/images/Menu_ChatOptions.svg'
                    text='Chattfunktioner'
                    onClick={this.props.onClick}
                    svgfill='#a25cbf'/>

                <MenuSubItem
                    svgSrc='/images/Menu_ChatsettingsQuickResponse.svg'
                    text='Konfigurera Snabbsvar' to='/chatSettings/quickResponse'
                    svgfill='#a25cbf'/>


            </Flex>
        )
    }
}

export default CompanySettings



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/MainMenu/ChatSettings/index.js